export default class NumberRounding {
    static round(val, decimals) {
        return +(Math.round(+(val.toFixed(decimals) + "e+" + decimals)) + "e-" + decimals);
    }
}